import { HERO_OUTLINE } from '../../../../shared/constants/heroOutline.js'
import { HERO_VIEW } from '../../../../shared/constants/heroView.js'

export function resolveModelOutlineControlsState({
  activeView,
  hasSiteModel,
  isOutlineVisible,
  availableOutlines = [],
  activeOutline,
  displayableProducts = [],
}) {
  const showBack = activeView === HERO_VIEW.BUILDING && hasSiteModel
  const hasBuildingsOutline = availableOutlines.includes(HERO_OUTLINE.BUILDINGS)

  return {
    showBack,
    showSelectorBackButton: showBack && !hasBuildingsOutline,
    useWideOutlineButtons: (
      activeView === HERO_VIEW.BUILDING
      && !hasSiteModel
      && !hasBuildingsOutline
      && availableOutlines.length === 2
    ),
    canUseLayerLegend: (
      isOutlineVisible
      && activeOutline === HERO_OUTLINE.APARTMENTS
      && displayableProducts.length > 0
    ),
    keepSelectorPinned: activeOutline === HERO_OUTLINE.APARTMENTS,
  }
}